export enum MessageFormActionEnum {
  CREATE,
  FORWARD,
  ANSWER_THREAD_CREATOR,
  ANSWER_DIRECTLY,
  FORWARD_MESSAGE,
}
